import { IconButton, Popover, Text } from '@oneaudi/unified-web-components';
import { TextVariant } from 'node_modules/@oneaudi/unified-web-components/dist/esm/components/text';
import { ReactNode, useState } from 'react';
import { TooltipLabelStyles } from '~/components/tooltip-label/styles/tooltip-label-style';
import { cn } from '~/utils/merge-classnames';

interface Props {
	label: string;
	tooltip: string | ReactNode;
	variant?: TextVariant;
	ariaLabel: string;
}

export const TooltipLabel = ({ label, tooltip, variant, ariaLabel }: Props) => {
	const [open, setOpen] = useState(false);
	return (
		<TooltipLabelStyles>
			<Text className={cn('tooltip-label')} variant={variant}>
				{label}
				<Popover
					id={'incentives-popover-title'}
					open={open}
					alignment="left"
					triggerElement={
						<IconButton
							variant="tertiary"
							size="sm"
							onClick={() => setOpen(true)}
							icon="info-circle"
							aria-label={ariaLabel}
						/>
					}
					content={
						typeof tooltip === 'string' ? (
							<Text variant={{ type: 'copy', order: '2', style: 'normal' }}>{tooltip}</Text>
						) : (
							tooltip
						)
					}
					onClose={() => setOpen(false)}
					withTip={false}
				/>
			</Text>
		</TooltipLabelStyles>
	);
};
